import React from 'react';
import PaymentDescription from '../Cart/PaymentDescription';

function WalletPaymentMethod() {
  return <PaymentDescription />;
}

export default WalletPaymentMethod;
